import axios, { AxiosError } from 'axios';

const GILIX_BASE_URL = 'https://mt.koku2v.gilix.com.br';

const gilixApi = axios.create({
    baseURL: GILIX_BASE_URL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

gilixApi.interceptors.request.use(
    config => Promise.resolve(config),
    async (error: AxiosError) => Promise.reject(error),
);

gilixApi.interceptors.response.use(
    (res) => Promise.resolve(res),
    async (error: AxiosError) => Promise.reject(error),
);

export default gilixApi;
